<template>
 <v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title>Add accommodation</v-card-title> 
    <v-form ref="addHuis" class="ma-4" v-model="addHuisValid"> 
     <v-row no-gutters>
      <v-col cols="12">
       <v-text-field v-model="getAddHuisData.eign_code_naam" readonly label="Homeowner"></v-text-field>
      </v-col>
     </v-row>
     <v-row>
      <v-col cols="12">
       <v-select v-model="getAddHuisData.ctrl_nr" :items="ctrl_nrKeuzes" item-value="ctrl_nr" item-text="ctrl_oms" label="Role" dense></v-select>
      </v-col>
     </v-row>
     <v-row>
      <v-col cols="12">
       <v-select v-model="getAddHuisData.land_code" :items="land_codeKeuzes" item-value="land_code" item-text="landtaal_oms" label="Accommodation Country" dense></v-select>
      </v-col>
     </v-row>
     <v-row no-gutters>
      <v-col cols="5">
       <v-text-field v-model="getAddHuisData.huis_postcode" label="Postal code digits"></v-text-field>
      </v-col>
      <v-col cols="2">
       <v-text-field v-model="dummy" label="OR" readonly=true></v-text-field>
      </v-col>
      <v-col cols="5">
       <v-text-field v-model="getAddHuisData.huis_code" label="Accommodation ID"></v-text-field>
      </v-col>
     </v-row>
     <v-row>
      <v-col cols="12"> 
        <p>A Real or Test accommodation ?   Test accommodation will be  XX.</p>
        <v-radio-group v-model="getAddHuisData.huis_realtest" :mandatory="true" row>
          <v-radio label="Real" value="Real"></v-radio>
          <v-radio label="Test" value="Test"></v-radio>
        </v-radio-group>
      </v-col>
     </v-row> 
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary ma-2" small @click="dialog = false">Close</v-btn>
      <v-btn class="primary ma-2" small :disabled="!addHuisValid" @click="addHuis">Add</v-btn>
    </v-card-actions>
  </v-card>   
 </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      eign_encrid: null,
      addHuisValid: null,
      getAddHuisData: {},
      land_codeKeuzes: [],
      ctrl_nrKeuzes: [],
      answer: null,
      dummy: ''
    }
  },
  methods: {
    open(eign_encrid) {
      var deze = this;
      this.dialog = true;
      this.eign_encrid = eign_encrid;
      this.$axios
        .post("ares/json/ares/eign/getAddHuisData.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getAddHuisData"
          },
          getAddHuisData: {
            eign_encrid: this.eign_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            deze.getAddHuisData = res.data.getAddHuisData;
            res.data.getAddHuisData.land_codeKeuzes.forEach(function(land) {
              deze.land_codeKeuzes.push(land);
              if (land.land_codeSelected === true) deze.getAddHuisData.land_code = land.land_code; 
            });
            res.data.getAddHuisData.ctrl_nrKeuzes.forEach(function(ctrl) {
              deze.ctrl_nrKeuzes.push(ctrl);
              if (ctrl.ctrl_nrSelected === true) deze.getAddHuisData.ctrl_nr = ctrl.ctrl_nr; 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHuis() {
      this.$axios
        .post("ares/json/ares/eign/addHuis.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHuis"
          },
          addHuis: {
            eign_encrid: this.getAddHuisData.eign_encrid,
            land_code: this.getAddHuisData.land_code,
            ctrl_nr: parseInt(this.getAddHuisData.ctrl_nr),
            huis_postcode:  this.getAddHuisData.huis_postcode,
            huis_code:  this.getAddHuisData.huis_code,
            huis_realtest: this.getAddHuisData.huis_realtest
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$router.reload('/huis/onHuis/' + res.data.addHuis.huis_encrid);
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHuis.text,
              color: res.data.addHuis.color
            });
            this.answer = true;
            this.dialog = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>




